import { render, staticRenderFns } from "./iconAbout.vue?vue&type=template&id=1fc5702e"
import script from "./iconAbout.vue?vue&type=script&lang=js"
export * from "./iconAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports